const educateMenu = [
  {
    label: 'About ED3N',
    items: [
      { key: 'aboutMissionStatement', label: 'ED3N Mission Statement' },
      { key: 'aboutDataUseAgreements', label: 'Data Use Agreements' },
      { key: 'aboutWhatDataED3NCollects', label: '   - What Data ED3N Collects' },
      { key: 'aboutDataElements', label: 'Data Elements' },
      { key: 'aboutDataLinkig', label: 'Data Linking' },
      { key: 'aboutExternalConnection', label: 'External Connections' },
      { key: 'aboutLegalNotices', label: 'Legal Notices' },
    ],
  },
  {
    label: 'ED3N Web Application',
    items: [
      { key: 'webAccessingED3N', label: 'Accessing ED3N' },
      { key: 'webAppSAMSClearance', label: '   - SAMS Clearance' },
      { key: 'webAppTestStagingSite', label: 'Test/Staging Site' },
      { key: 'webAppVersions', label: 'Versions' },
    ],
  },
  {
    label: 'Understanding and Using ED3N',
    items: [
      { key: 'understandEvaluate', label: 'Evaluate' },
      { key: 'understandExploreOverview', label: '    Overview' },
      { key: 'understandExploreOverviewUserGuide', label: '   - User Guide' },
      { key: 'understandExploreOverviewProgramSummaryPage', label: '   - Program Summary Page' },
      { key: 'understandExploreOverviewViewingSpecimen', label: '   - Viewing Specimen and Patient Data' },
      { key: 'understandExploreBiochemical', label: '    Biochemical Module' },
      { key: 'understandExploreBiochemicalRiskAssessment', label: '   - Risk Assessment Basics' },
      { key: 'understandExploreBiochemicalMachineLearningBasics', label: '   - Machine Learning Basics' },
      { key: 'understandExploreBiochemicalAnalyteAndDiseases', label: '   - Analytes and Diseases' },
      { key: 'understandExploreBiochemicalInterpretingData', label: '   - Interpreting Data Visualizations' },
      { key: 'understandExploreMolecular', label: '    Molecular Module' },
      { key: 'understandExploreMolecularRiskAssessment', label: '   - Variant Interpretation Basics' },
      { key: 'understandExploreMolecularMachineLearningBasics', label: '   - Consensus Reviews' },
      { key: 'understandExploreMolecularAnalyteAndDiseases', label: '   - Evidence Sources' },
      { key: 'understandExploreMolecularInterpretingData', label: '   - Genomenon' },
      { key: 'understandExploreClinical', label: '    Clinical Module' },
      { key: 'understandExploreClinicalDiseaseDefinitions', label: '   - Disease Definitions' },
      { key: 'understandExploreClinicalAboutECR', label: '   - About eCR' },
      { key: 'understandExploreClinicalAboutFHIR', label: '   - About FHIR' },
      { key: 'understandExploreExplore', label: '    Explore' },
      { key: 'understandExploreExploreOverview', label: '   Overview' },
      { key: 'understandExploreExploreProgramData', label: '   - View Program Data' },
      { key: 'understandExploreExploreNationalAggregateData', label: '   - View National Aggregate Data' },
    ],
  },
  {
    label: 'ED3N Support',
    items: [
      { key: 'supportContactInformation', label: 'Contact Information' },
      { key: 'supportSuggestNewFeatures', label: 'Suggest New Features' },
    ],
  },
];

export default educateMenu;